import { SectionItem } from '@features/shift-post-v2/components'
import { ShiftPostStep } from '@features/shift-post-v2/steps'
import { Text } from '@pinchenterprisesnpm/friday-ui'
import { connect } from 'formik'
import { Summary } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/summary/summary'
import { useModal } from '@src/hooks/useModal'
import { AcceptanceCriteriaModal } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/modals/acceptance-criteria-modal/acceptance-criteria-modal'
import { IWhoCanWorkSectionProps } from './who-can-work-section.types'
import { RadioGroup } from './components/radio-group'

export const WhoCanWorkSection = connect<IWhoCanWorkSectionProps>(({ sourceStep }) => {
  const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM
  const [isOpen, toggleModal, closeModal] = useModal()

  return (
    <SectionItem
      title={isConfirmStep ? 'Acceptance Criteria' : 'Who can work at this shift?'}
      hasEdit={isConfirmStep}
      onEdit={toggleModal}
    >
      {isConfirmStep ? (
        <>
          <Summary />

          <AcceptanceCriteriaModal isOpen={isOpen} closeModal={closeModal} />
        </>
      ) : (
        <>
          <Text>All Upshifters are pre-vetted and have passed background checks.</Text>
          <RadioGroup />
        </>
      )}
    </SectionItem>
  )
})
